/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ElementsUserMini,
    ElementsUserMiniFromJSON,
    ElementsUserMiniFromJSONTyped,
    ElementsUserMiniToJSON,
    MediaRootMini,
    MediaRootMiniFromJSON,
    MediaRootMiniFromJSONTyped,
    MediaRootMiniToJSON,
    MediaRootPermission,
    MediaRootPermissionFromJSON,
    MediaRootPermissionFromJSONTyped,
    MediaRootPermissionToJSON,
    VolumeMini,
    VolumeMiniFromJSON,
    VolumeMiniFromJSONTyped,
    VolumeMiniToJSON,
} from './';

/**
 * 
 * @export
 * @interface MediaFile
 */
export interface MediaFile {
    /**
     * 
     * @type {number}
     * @memberof MediaFile
     */
    id: number;
    /**
     * 
     * @type {VolumeMini}
     * @memberof MediaFile
     */
    volume: VolumeMini;
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof MediaFile
     */
    info?: { [key: string]: string | undefined; };
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof MediaFile
     */
    customFields?: { [key: string]: string | undefined; };
    /**
     * 
     * @type {MediaRootPermission}
     * @memberof MediaFile
     */
    resolvedPermission?: MediaRootPermission;
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof MediaFile
     */
    readonly parentFile?: { [key: string]: string | undefined; };
    /**
     * 
     * @type {MediaRootMini}
     * @memberof MediaFile
     */
    root?: MediaRootMini;
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof MediaFile
     */
    readonly effectiveCustomFields: { [key: string]: string | undefined; } | null;
    /**
     * 
     * @type {ElementsUserMini}
     * @memberof MediaFile
     */
    modifiedBy?: ElementsUserMini;
    /**
     * 
     * @type {string}
     * @memberof MediaFile
     */
    readonly fullPath: string;
    /**
     * 
     * @type {boolean}
     * @memberof MediaFile
     */
    readonly isShared: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MediaFile
     */
    readonly isExcluded: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaFile
     */
    readonly isHardlink: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaFile
     */
    readonly isBookmarked: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof MediaFile
     */
    readonly childCount: number | null;
    /**
     * 
     * @type {string}
     * @memberof MediaFile
     */
    readonly name: string;
    /**
     * 
     * @type {string}
     * @memberof MediaFile
     */
    readonly path: string;
    /**
     * 
     * @type {string}
     * @memberof MediaFile
     */
    readonly pathhash: string;
    /**
     * 
     * @type {string}
     * @memberof MediaFile
     */
    readonly ancestry: string;
    /**
     * 
     * @type {boolean}
     * @memberof MediaFile
     */
    readonly isDir: boolean;
    /**
     * 
     * @type {number}
     * @memberof MediaFile
     */
    totalFiles?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MediaFile
     */
    readonly size: number;
    /**
     * 
     * @type {number}
     * @memberof MediaFile
     */
    readonly mtime: number;
    /**
     * 
     * @type {boolean}
     * @memberof MediaFile
     */
    readonly present: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaFile
     */
    needsRescan?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaFile
     */
    readonly isShowroom: boolean;
    /**
     * 
     * @type {number}
     * @memberof MediaFile
     */
    readonly bundleIndex: number;
    /**
     * 
     * @type {Date}
     * @memberof MediaFile
     */
    readonly modified: Date;
    /**
     * 
     * @type {number}
     * @memberof MediaFile
     */
    readonly parent?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MediaFile
     */
    readonly bundle?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof MediaFile
     */
    bookmarkedBy?: Array<number>;
}

export function MediaFileFromJSON(json: any): MediaFile {
    return MediaFileFromJSONTyped(json, false);
}

export function MediaFileFromJSONTyped(json: any, ignoreDiscriminator: boolean): MediaFile {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'volume': VolumeMiniFromJSON(json['volume']),
        'info': !exists(json, 'info') ? undefined : json['info'],
        'customFields': !exists(json, 'custom_fields') ? undefined : json['custom_fields'],
        'resolvedPermission': !exists(json, 'resolved_permission') ? undefined : MediaRootPermissionFromJSON(json['resolved_permission']),
        'parentFile': !exists(json, 'parent_file') ? undefined : json['parent_file'],
        'root': !exists(json, 'root') ? undefined : MediaRootMiniFromJSON(json['root']),
        'effectiveCustomFields': json['effective_custom_fields'],
        'modifiedBy': !exists(json, 'modified_by') ? undefined : ElementsUserMiniFromJSON(json['modified_by']),
        'fullPath': json['full_path'],
        'isShared': json['is_shared'],
        'isExcluded': json['is_excluded'],
        'isHardlink': json['is_hardlink'],
        'isBookmarked': json['is_bookmarked'],
        'childCount': json['child_count'],
        'name': json['name'],
        'path': json['path'],
        'pathhash': json['pathhash'],
        'ancestry': json['ancestry'],
        'isDir': json['is_dir'],
        'totalFiles': !exists(json, 'total_files') ? undefined : json['total_files'],
        'size': json['size'],
        'mtime': json['mtime'],
        'present': json['present'],
        'needsRescan': !exists(json, 'needs_rescan') ? undefined : json['needs_rescan'],
        'isShowroom': json['is_showroom'],
        'bundleIndex': json['bundle_index'],
        'modified': (new Date(json['modified'])),
        'parent': !exists(json, 'parent') ? undefined : json['parent'],
        'bundle': !exists(json, 'bundle') ? undefined : json['bundle'],
        'bookmarkedBy': !exists(json, 'bookmarked_by') ? undefined : json['bookmarked_by'],
    };
}

export function MediaFileToJSON(value?: MediaFile | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'volume': VolumeMiniToJSON(value.volume),
        'info': value.info,
        'custom_fields': value.customFields,
        'resolved_permission': MediaRootPermissionToJSON(value.resolvedPermission),
        'root': MediaRootMiniToJSON(value.root),
        'modified_by': ElementsUserMiniToJSON(value.modifiedBy),
        'total_files': value.totalFiles,
        'needs_rescan': value.needsRescan,
        'bookmarked_by': value.bookmarkedBy,
    };
}


